import React, { Fragment } from 'react';
import { ArrowRight, RefreshCw } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function PainAgitation() {
  const {
    ref,
    isVisible
  } = useInView();
  const cycleSteps = ['Cobrar', 'Pagar deudas', 'Cubrir lo básico', 'Llegar justo'];
  return <section className="py-24 px-4" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <div ref={ref} className={isVisible ? 'anim-fade-up' : 'anim-hidden'} data-id="element-162">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-163">
            Pensá en el último día 25 del mes.
          </h2>
          <p className="text-xl text-gray-300 mb-6" data-id="element-164">
            ¿Cuánto te quedaba en la cuenta?
          </p>
          <p className="text-lg text-gray-400 mb-12" data-id="element-165">
            Si la respuesta te generó incomodidad, seguí leyendo. Porque lo que
            estás a punto de descubrir va a cambiar la forma en que receptás tu
            próximo sueldo para siempre.
          </p>

          <div className="bg-[#141414] border border-gray-800 rounded-2xl p-8 mb-12 relative overflow-hidden" data-id="element-166">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[50px] rounded-full" data-id="element-167" />
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-widest mb-8 text-center" data-id="element-168">
              El ciclo que vivís hoy se ve así:
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-2" data-id="element-169">
              {cycleSteps.map((step, index) => <Fragment key={index} data-id="element-170">
                  <div className="bg-[#1A1A1A] border border-gray-800 px-4 py-3 rounded-lg text-center min-w-[140px]" data-id="element-171">
                    <span className="text-gray-300 font-medium" data-id="element-172">{step}</span>
                  </div>
                  {index < cycleSteps.length - 1 && <ArrowRight className="w-5 h-5 text-gray-600 rotate-90 md:rotate-0" data-id="element-173" />}
                </Fragment>)}
              <ArrowRight className="w-5 h-5 text-gray-600 rotate-90 md:rotate-0" data-id="element-174" />
              <div className="bg-red-950/30 border border-red-900/50 px-4 py-3 rounded-lg text-center min-w-[140px] flex items-center justify-center gap-2" data-id="element-175">
                <RefreshCw className="w-4 h-4 text-red-400" data-id="element-176" />
                <span className="text-red-400 font-medium" data-id="element-177">Repetir</span>
              </div>
            </div>
          </div>

          <div className="space-y-6 text-lg text-gray-300" data-id="element-178">
            <p data-id="element-179">
              Y cada vez que llega el sueldo, hay una pequeña esperanza.{' '}
              <span className="italic text-white" data-id="element-180">
                "Este mes voy a ahorrar." "Este mes voy a organizarme." "Este
                mes va a ser diferente."
              </span>
            </p>
            <p className="font-bold text-white text-xl" data-id="element-181">
              Pero no es diferente.
            </p>
            <p data-id="element-182">
              Porque el problema no sos vos.{' '}
              <strong className="text-gold-400 font-semibold" data-id="element-183">
                El problema es el orden en que hacés las cosas.
              </strong>
            </p>
            <div className="bg-[#1A1A1A] p-6 rounded-xl border-l-4 border-gray-600 my-8" data-id="element-184">
              <p className="text-gray-400 italic mb-2" data-id="element-185">
                El sistema tradicional te dice:
              </p>
              <p className="text-xl text-white font-serif" data-id="element-186">
                "Gastá lo que necesitás y ahorrá lo que sobre."
              </p>
            </div>
            <p className="text-2xl font-bold text-white" data-id="element-187">
              El problema es que nunca sobra nada.
            </p>
            <p className="text-gray-400" data-id="element-188">
              Y así, mes a mes, año a año, el tiempo pasa. El sueldo pasa. Y la
              posibilidad de construir algo real… también pasa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}